export default class CreateCCDRPayload {
    public companyId?: number;
    public mailTitle = "";
    public mailText = "";
    public requestTitle = "";
    public requestDescription?: string;
}